/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */

import { AssistStatus } from '../../../types/model';

const thickness = 2;

export function underlineStyle(status: AssistStatus, element: HTMLElement) {
    switch (status) {
        case 'error': {
            element.style.borderBottom = `${thickness}px solid rgb(255,44,44)`;
            break;
        }
        case 'warning': {
            element.style.borderBottom = `${thickness}px solid rgb(255,191,94)`;
            break;
        }
        case 'unknown': {
            element.style.borderBottom = `${thickness}px solid rgb(190,190,190)`;
            break;
        }
        case 'noproblem': {
            break;
        }
        case 'hint': {
            element.style.borderBottom = `${thickness}px solid rgb(111,165,255)`;
            break;
        }
        case 'success': {
            element.style.borderBottom = `${thickness}px solid rgb(106,200,0)`;
            break;
        }
        default:
            return;
    }
}

export function backgroundStyle(status: AssistStatus, element: HTMLElement) {
    switch (status) {
        case 'error': {
            element.style.backgroundColor = 'rgba(253,109,109,0.2)';
            break;
        }
        case 'warning': {
            element.style.backgroundColor = 'rgba(246,204,106,0.2)';
            break;
        }
        case 'unknown': {
            element.style.backgroundColor = 'rgba(141,140,140,0.2)';
            break;
        }
        case 'noproblem': {
            break;
        }
        case 'hint': {
            element.style.backgroundColor = 'rgba(156,187,255,0.2)';
            break;
        }
        case 'success': {
            element.style.backgroundColor = 'rgba(181,255,91,0.2)';
            break;
        }
        default: {
            element.style.backgroundColor = 'transparent';
            break;
        }
    }
}
